import { isLocal } from '@/constants';
import { mockConfig } from '@/mockConfig';
import { message } from 'antd';
import axios from 'axios';
import _, { get } from 'lodash';
import { udataLogin } from './login';
import { tokenUtil } from './token';

const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-Type': 'application/json;charset=utf-8',
  Accept: 'application/json',
  lang: window.localStorage.getItem('locale'),
  Authorization: tokenUtil.get()
};

const service = axios.create({
  url: '',
  method: 'post',
  baseURL: '/promeApi',
  headers: headers,
  timeout: 60 * 1000,
  withCredentials: true, // 表示跨域请求时是否需要使用凭证
  responseType: 'json', // 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  maxContentLength: 4000 // 定义允许的响应内容的最大尺寸
});

// 添加请求拦截器
service.interceptors.request.use(
  function (config: any) {
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    const _notAlert = response?.config?.headers?._notAlert;
    if (response.data?.statusCode !== 200) {
      // 4001：需要 OIDC 授权。不在拦截器层弹错误，交由业务层处理跳转。
      if (response.data?.statusCode === 4001) {
        const oidcError: any = new Error(response.data?.desc || '需要 OIDC 授权');
        oidcError.statusCode = 4001;
        oidcError.isOidcRequired = true;
        oidcError.response = response.data;
        return Promise.reject(oidcError);
      }
      if (response.config?.errorHandle) {
        response.config?.errorHandle(response.data);
      }
      if (!_notAlert) {
        message.error(response.data?.desc);
      }
      // message.error(response.data?.desc?.slice(0, 50));
      return Promise.reject(response.data?.desc);
    }
    return response.data?.data; // TODO: 后端内容国际化翻译处理
  },
  function (error) {
    if (get(error, 'response.data.desc')) {
      message.error(get(error, 'response.data.desc'));
    }
    if (get(error, 'response.status') === 401) {
      message.error('登录信息过期，请重新登录');
      tokenUtil.remove();
      udataLogin();
      return;
    }
    if (error.name === 'CanceledError') {
      return Promise.reject('CanceledError');
    }
    message.error({ content: '服务器错误，请重试', duration: 2 });
    return Promise.reject(error);
  }
);
export function request(
  path: string,
  params: { [key: string]: any } = {},
  payload: Request.IPayload = {}
): Promise<any> {
  const { _notAlert = false, ...data } = params;

  //默认
  const option = {
    url: path,
    headers: { _notAlert },
    data: {
      __fix: new Date().getTime(), // 修复后端无body参数造成的bug，通过外部config传入
      ...data
    },
    ...payload
  };
  //根据不同的环境和配置设置部分调试参数
  if (path && isLocal && mockConfig.list.includes(path)) {
    Object.assign(option, {
      baseURL: '/api'
    });
  }
  return service(option);
}

export function fileRequest(
  path: string,
  params: {
    file: File | File[];
    [key: string]: any;
  },
  payload: Request.IPayload = {}
): Promise<any> {
  const formData = new FormData();
  Object.entries(params).forEach(([key, value]) => {
    if (key === 'files' || key === 'file') {
      value.forEach((v) => {
        formData.append(key, v);
      });
    } else {
      formData.append(key, value);
    }
  });

  const option = {
    url: path,
    data: formData,
    headers: {
      ...headers,
      'Content-Type': undefined,
      ...payload.headers,
      Authorization: tokenUtil.get()
    },
    ..._.omit(payload, 'headers')
  };
  return service(option);
}
